var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.imageDate),function(item){return _c('TypeCell',{attrs:{"Key":item.imagePath,"imgPath":item.imagePath}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }